import apiClient from "./base.service";

export default {
  async index(event_id) {
    return await apiClient.get(`/event/${event_id}/shift`);
  },
  async my() {
    return await apiClient.get(`/me/shifts`);
  },
  async update(event_id, team_id, task_id, id, data) {
    return await apiClient.put(
      `/event/${event_id}/team/${team_id}/task/${task_id}/shift/${id}`,
      data
    );
  },
  async forceAssign(event_id, team_id, task_id, id, userId) {
    return await apiClient.put(
      `/event/${event_id}/team/${team_id}/task/${task_id}/shift/${id}/forceAssign`,
      { user: userId }
    );
  },
  async forceCancel(event_id, team_id, task_id, id) {
    return await apiClient.get(
      `/event/${event_id}/team/${team_id}/task/${task_id}/shift/${id}/forceCancel`
    );
  },
  async assign(event_id, id) {
    return await apiClient.put(`/event/${event_id}/shift/${id}/assign`, {});
  },
  async cancel(event_id, id) {
    return await apiClient.put(`/event/${event_id}/shift/${id}/cancel`, {});
  },
  async hasArrived(event_id, team_id, task_id, id, hasArrived) {
    return await apiClient.put(
      `/event/${event_id}/team/${team_id}/task/${task_id}/shift/${id}/arrived/${hasArrived ? "yes" : "no"}`
    );
  },
};
